<div [id]="id + '750037fb-467f-4375-9b4d-3523ff977acd'" class="dropdown" ngbDropdown placement="bottom-right">
  <button [id]="id + 'd84f7617-2785-4805-955f-e45394ecd3cc'" class="btn dropdown-toggle" type="button" [id]="id" ngbDropdownToggle>
    <ng-content select="button"></ng-content>
  </button>
  <div [id]="id + '92f95773-c954-4329-b549-0e85949be6f4'" class="dropdown-menu" [attr.aria-labelledby]="id" ngbDropdownMenu>
    <ng-content select="menu"></ng-content>
  </div>
</div>
